const COMPLEXITY = [{ id: 1, name: "1" }, { id: 2, name: "2" }, { id: 3, name: "3" }, { id: 4, name: "4" }];
const DATA_PROCESSING = [{ id: 1, name: "Yes" }, { id: 2, name: "Fixed width" }, { id: 3, name: "No" }];
const PROJECT_TYPES = [{ id: 2, name: "Revelation" }, { id: 1, name: "Decipher" }, { id: 0, name: "InterVu" }, { id: 3, name: "LiveVideo" }];
const ASSIGNMENT_STATUS_TYPES = [{ id: 0, name: "Pending" }, { id: 1, name: "Accepted" }, { id: 2, name: "Rejected" }];
const CONTACT_TYPES = [{ id: 0, name: "Translators" }, { id: 1, name: "Recruiters" }, { id: 2, name: "Moderators" }, { id: 3, name: "Facility Contacts" }]

class StaticData {

  static get Complexity() {
    return COMPLEXITY;
  }

  static get DataProcessing() {
    return DATA_PROCESSING;
  }

  static get ProjectTypes() {
    return PROJECT_TYPES;
  }

  static get AssignmentStatusTypes() {
    return ASSIGNMENT_STATUS_TYPES;
  }

  static get ContactTypes() {
    return CONTACT_TYPES;
  }
}

export default StaticData;



// WEBPACK FOOTER //
// ./src/services/StaticData.js